export default __webpack_public_path__ + "static/media/shopshop.fcfac582.png";